module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1004-50a1adf541ce28595ef7cff1c3934c5c.png";